import {Injectable} from '@angular/core';
import {HttpFilterParam} from 'prod-shared';
import {OrganizationService} from "./organization.service";

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends OrganizationService {
  override getSelectFilters(): HttpFilterParam[] {
    return [{
      property: 'organizationType',
      operator: 'eq',
      value: 1
    }];
  }
}
